"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserManagementService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const user_management_repository_1 = require("./user-management.repository");
let UserManagementService = class UserManagementService {
    constructor(repo) {
        this.repo = repo;
    }
    createUser(data) {
        return this.repo.createUser(data);
    }
    updateUser(id, data) {
        return this.repo.updateUser(id, data);
    }
    async deleteUser(id) {
        await this.repo.softDeleteUser(id);
    }
    getUsers(page = 1, limit = 10, type) {
        return this.repo.getUsers((page - 1) * limit, limit, type);
    }
};
exports.UserManagementService = UserManagementService;
exports.UserManagementService = UserManagementService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof user_management_repository_1.UserManagementRepository !== "undefined" && user_management_repository_1.UserManagementRepository) === "function" ? _a : Object])
], UserManagementService);
